export const onlyDigits = (value) => String(value || '').replace(/\D/g, '');

export const maskCep = (value) => {
    const digits = onlyDigits(value).slice(0, 8);
    return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
};

export const maskPhone = (value) => {
    const digits = onlyDigits(value).slice(0, 11);
    if (digits.length === 0) return '';
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

export const maskRg = (value) => {
    let clean = String(value || '').toUpperCase().replace(/[^0-9X]/g, '');
    if (clean.includes('X')) {
        const hasTrailingX = clean.endsWith('X') && clean.length >= 8;
        clean = clean.replace(/X/g, '');
        if (hasTrailingX) {
            clean += 'X';
        }
    }
    clean = clean.slice(0, 9);

    if (clean.length === 0) return '';
    if (clean.length <= 2) return clean;
    if (clean.length <= 5) return `${clean.slice(0, 2)}.${clean.slice(2)}`;
    if (clean.length <= 8) {
        if (clean.endsWith('X')) {
            return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 7)}-${clean.slice(7)}`;
        }
        return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5)}`;
    }
    return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}-${clean.slice(8)}`;
};

export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

